<!-- whatsapp floating button -->
<div class="whatsapp position-fixed">
    <div class="rounded-circle bg-white shadow align-items-center justify-content-center d-flex">
        <img src="assets/img/whatsApp.svg">
    </div>
</div>
<!-- END whatsapp floating button -->